import { get, isNull, keyBy } from 'lodash';
import { isPlatform } from '@ionic/core';
import {
  Plugins,
  FilesystemDirectory,
  FilesystemEncoding,
} from '@capacitor/core';
import format from 'date-fns/format';

import { FileOpener } from '@ionic-native/file-opener';

const { Filesystem } = Plugins;

const URL_PROTOCOL_REGEX = /^(.*:\/\/)/i;

export const parseJwt = token => {
  if (!token) return null;

  const base64Url = token.split('.')[1];
  if (!base64Url) return null;

  const base64 = base64Url.replace('-', '+').replace('_', '/');
  return window.atob(base64);
};

export function hashById(array) {
  return keyBy(array, 'id');
}

export const formatPhoneNumber = phoneNumber => {
  return !phoneNumber
    ? ''
    : phoneNumber
        .replace(/\D/g, '')
        .replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
};

export const formatPhoneLink = (phoneNumber, extension) => {
  const withExtension = extension ? `,,${extension}` : '';

  return !phoneNumber
    ? ''
    : phoneNumber
        .replace(/\D/g, '')
        .replace(/(\d{3})(\d{3})(\d{4})/, `$1-$2-$3${withExtension}`);
};

export const formatAddress = (city, state, zip) =>
  `${[city, state].filter(x => !!x).join(', ')} ${zip}`;

export const formatDate = date => format(date, 'YYYY-MM-DD');

export const getFormValue = (object, path, defaultValue) => {
  const result = get(object, path, defaultValue);
  return isNull(result) ? defaultValue : result;
};

export const toHref = url =>
  URL_PROTOCOL_REGEX.exec(url) ? url : `http://${url}`;

export const saveBlobFile = (blob, fileName = 'file.pdf') => {
  // IE doesn't allow blob object links so we need to use msSaveOrOpenBlob instead
  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(blob, fileName);
    return;
  }

  const fileWrite = async () => {
    try {
      const reader = new FileReader();
      reader.onload = async () => {
        if (isPlatform('android')) {
          const pdfBase64 = reader.result.split(',')[1];

          Filesystem.writeFile({
            path: fileName,
            data: pdfBase64,
            directory: FilesystemDirectory.Documents,
            // encoding: FilesystemEncoding.UTF8
          }).then(writeFileResult => {
            Filesystem.getUri({
              directory: FilesystemDirectory.Documents,
              path: fileName,
            }).then(
              getUriResult => {
                const path = getUriResult.uri;

                FileOpener.open(path, 'application/pdf')
                  .then(() => console.log('File is opened'))
                  .catch(error => console.log('Error opening file', error));
              },
              error => {
                console.log(error);
              },
            );
          });
        } else if (isPlatform('ios')) {
          await Filesystem.writeFile({
            path: fileName,
            data: reader.result.split(',')[1],
            directory: FilesystemDirectory.Downloads,
          });

          let ret = await Filesystem.getUri({
            path: fileName,
            directory: FilesystemDirectory.Downloads,
          });
          FileOpener.open(ret.uri, 'application/pdf').then(() =>
            console.log('file open'),
          );
        } else {
          const data = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          document.body.appendChild(link);
          link.href = data;
          link.download = fileName;
          link.click();
          setTimeout(() => {
            // timeout needed for iOS safari
            window.URL.revokeObjectURL(data);
          }, 100);
          document.body.removeChild(link);
        }
      };

      // No special handling needed for web app
      reader.readAsDataURL(blob);
    } catch (e) {
      console.error('Unable to write file', e);
    }
  };

  fileWrite();
};



// WEBPACK FOOTER //
// ./src/util/helpers.js